import { Box, FormControl, IconButton, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { bhpButtonSx } from "../../styles/bhpStyles";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useState } from "react";
import { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { MINUTES_STEP, ScheduleSlot } from "./types/scheduleSlot";
import { DoorState } from "./enums/DoorState";
import { v4 as uuidv4 } from 'uuid';
import { ScheduleSlotData } from "./types/scheduleSlotData";

type DashboardEventsLatestProps = {
    
    addRow ( scheduleSlot: ScheduleSlot ): void ;
    editScheduleSlot( scheduleSlotData: ScheduleSlotData ): void;
    removeRow ( slotId: string ): void;
    scheduleSlot: ScheduleSlot;

};

export const ScheduleItem: React.FC< DashboardEventsLatestProps > = ( props: DashboardEventsLatestProps ) => {

    const { addRow, editScheduleSlot, removeRow, scheduleSlot } = props;

    const [ doorState, setDoorState ] = useState<DoorState>( scheduleSlot.doorState );
    const [ pickedTime, setPickedTime ] = useState<Dayjs | null>( scheduleSlot.actualTime );

    const handleAddClick = () => {

        addRow({ 
            
            actualTime: (pickedTime as Dayjs).add( MINUTES_STEP, 'minute' ), 
            canAddRow: false, 
            canEditTime: false, 
            canRemoveRow: false, 
            doorState: doorState, 
            minTime: (pickedTime as Dayjs).add( MINUTES_STEP, 'minute' ),
            slotId: uuidv4(),
            
        });

    };

    const handleDoorStateChange = ( event: SelectChangeEvent<DoorState> ) => {
        
        const newDoorState: DoorState = event.target.value as DoorState;
        setDoorState( newDoorState );
        editScheduleSlot({ actualTime: pickedTime as Dayjs, doorState: newDoorState, slotId: scheduleSlot.slotId });

    };


    const handleRemoveClick = () => removeRow( scheduleSlot.slotId );

   
    const handleTimePickerChange = (newPickedTime: Dayjs | null) => {
    
        setPickedTime( newPickedTime );
        editScheduleSlot({ actualTime: newPickedTime as Dayjs, doorState, slotId: scheduleSlot.slotId });
    
    };


    return(
        <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 } alignItems="center" sx={{ marginBottom: '5px', }}>
            
            {
                scheduleSlot.canAddRow 
                    ?
                <IconButton 
                    sx={{ ...bhpButtonSx, height: '25px', width: '25px' }}
                    onClick={ handleAddClick }
                >
                    <AddIcon sx={{ height: '20px', width: '20px' }}/>
                </IconButton>
                    :
                <Box sx={{ height: '25px', width: '25px' }}/>
            }
            
            <LocalizationProvider dateAdapter={ AdapterDayjs } adapterLocale="en-au">
            
            <TimePicker 
                sx={{ width: '200px' }}
                ampm={ false }
                readOnly={ !scheduleSlot.canEditTime }
                value={ pickedTime }
                minTime={ scheduleSlot.minTime }
                // minutesStep={ MINUTES_STEP }
                onChange={ handleTimePickerChange }
            />
            </LocalizationProvider>

            <FormControl sx={{ width: '200px' }}>
                <Select value={ doorState }
                    onChange={ handleDoorStateChange }
                >
                    <MenuItem value={ DoorState.Secure }>{ DoorState.Secure }</MenuItem>
                    <MenuItem value={ DoorState.SecureUsePin }>{ DoorState.SecureUsePin }</MenuItem>
                    <MenuItem value={ DoorState.Free }>{ DoorState.Free }</MenuItem>
                    <MenuItem value={ DoorState.FreeUsePin }>{ DoorState.FreeUsePin }</MenuItem>
                </Select>
            </FormControl>

            {
                scheduleSlot.canRemoveRow
                    ?
                <IconButton 
                    sx={{ ...bhpButtonSx, height: '25px', width: '25px' }}
                    onClick={ handleRemoveClick }
                >
                    <RemoveIcon sx={{ height: '20px', width: '20px' }}/>
                </IconButton>
                    :
                <Box sx={{ height: '25px', width: '25px' }}/>
            }
        </Stack>
    );

};

